
import angular from 'angular';
import { DatalayerConstantsType } from 'ib-web-commons/dist/app/core/ib-datalayer/ib-datalayer-constants';
import { AncillariesUtilsService } from '../../../../shared/ib-web-ancillaries-utils';

const controllerInfo = {
    module: 'ib-special-meals-module',
    inject: ['object', '$uibModalInstance', '$scope', '$filter', 'AncillariesMealsService', 'AncillariesConstants', 'DatalayerUtilsService', '$rootScope', 'localStorageService', '$timeout', 'CommonsConstants', 'DatalayerConstants'],
    required: []
};

export class SpecialMealsController implements ng.IController {

    public model;
    public currentSegmentIndex = 0;
    public currentSegment;
    public totalSegment = 0;
    public passengers = [];
    public currentPassenger;
    public menus = {};
    public lastSegment = false;
    public currentPassengerIndex = 0;
    public specialMealDefault;
    public errorCode = '';
    public specialMealNotIncluded;
    public specialMealDefaultDesc;
    public specialMealNALess4Hours = false;
    constructor (
        private object: any,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private $scope: angular.IScope,
        private $filter: any,
        private AncillariesMealsService: any,
        private AncillariesConstants: AncillariesConstant,
        private DatalayerUtilsService: DatalayerUtilsService,
        private $rootScope: CommonsRootScope,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private $timeout: ng.ITimeoutService,
        private CommonsConstants: CommonsConstantsType,
        private DatalayerConstants: DatalayerConstantsType) {
        this.model = object;
        this.specialMealDefaultDesc = this.$filter('translate')('MMB_ANCILLARIES_SPECIAL_MEALS_DEFAULT_MENU_DESC');
        this.specialMealNotIncluded = this.$filter('translate')('MMB_ANCILLARIES_SPECIAL_MEALS_NOT_INCLUDED');
    }



    $onInit (): void {
        let i = 1;
        //Events
        this.$scope.$on('selectScrollPassenger', this.selectScrollPassenger);

        this.filterAvailableSegments();
        this.filterAvailableOrderMeals();

        if (this.model.activeSegment && this.model.activeSegment.id_segment) {
            while (i < this.model.specialMealSegments.length) {
                if (this.model.specialMealSegments[i].id === this.model.activeSegment.id_segment) {
                    this.currentSegmentIndex = i;
                    this.currentSegment = this.model.specialMealSegments[this.currentSegmentIndex];
                }
                i++;
            }
            // If there is no available flight we leave on the screen the last
            this.model.activeSegment = undefined;
        }

        if (this.model && this.model.specialMealSegments.length > 0 && this.model.passengersInfo.length > 0) {
            this.totalSegment = this.model.specialMealSegments.length;
            // the first trip is selected by default
            if (this.model.isGastronomicProposal) {
                this.currentSegmentIndex = this.model.specialMealSegments.findIndex(seg => seg.id === this.model.gastronomicProposalSegmentId);
                this.lastSegment = true;
            }
            this.currentSegment = this.model.specialMealSegments[this.currentSegmentIndex];
            // the first passenger is selected by default
            this.currentPassenger = this.model.passengersInfo[this.currentPassengerIndex];
        }

        if (this.currentSegmentIndex === this.totalSegment - 1) {
            this.lastSegment = true;
        }

        // fill in the menus array by default
        this.fillMenus();
        // fill in the passengers array to pass it to the scroll component (binding)
        this.passengers = this.getCurrentPassengers();
        this.errorFilter();
        this.$timeout(() => {
            /* INIT DELETE GA4 MIGRATION */
            this.DatalayerUtilsService.updateDatalayerWithQuadrigam(this.CommonsConstants.QUADRIGAM.MODAL_INF_SPECIAL_MEAL, null, this.localStorageService.get('userLogged'));
            this.DatalayerUtilsService.sendDatalayerEvent(this.DatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);
            /* FINISH DELETE GA4 MIGRATION*/
            this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(this.CommonsConstants.QUADRIGAM.MODAL_INF_SPECIAL_MEAL, null, this.localStorageService.get('userLogged'));
            this.DatalayerUtilsService.updateDatalayerViewEvent();
        });
    }

    errorFilter = (): void => {
        this.specialMealNALess4Hours = false;
        if(this.currentSegment.status.reason === 'SML_AVAIL_ERR_0005' || this.currentSegment.status.reason === this.$filter('translate')('MMB_ANCILLARIES_SPECIAL_MEALS_NOT_IBERIA_CONTENT')) {
            this.errorCode = this.$filter('translate')('MMB_ANCILLARIES_SPECIAL_MEALS_NOT_IBERIA_FLIGHT');
        } else if (this.currentSegment.status.reason === 'SML_AVAIL_ERR_0004' || this.currentSegment.status.reason === this.$filter('translate')('MMB_ANCILLARIES_SPECIAL_MEALS_LESS_THAN_4_HOURS_CONTENT')) {
            this.specialMealNALess4Hours = true;
            this.errorCode = this.$filter('translate')('MMB_ANCILLARIES_SPECIAL_MEALS_LESS_THAN_4_HOURS_MSG');
        } else if (this.currentSegment.status.reason === 'SML_AVAIL_ERR_0003' || this.currentSegment.status.reason === this.$filter('translate')('MMB_ANCILLARIES_SPECIAL_MEALS_LESS_THAN_24_HOURS_CONTENT')) {
            if(this.menus[this.currentSegment.id].passengers[this.currentPassenger.id].menu === 'standard') {
                this.errorCode = this.$filter('translate')('MMB_CUSTOMIZE_FLIGHTS_SPECIAL_MEALS_MEAL_NO_SELECTED_LABEL');
            } else if(this.menus[this.currentSegment.id].passengers[this.currentPassenger.id].menu !== 'standard') {
                this.errorCode = this.$filter('translate')('MMB_CUSTOMIZE_FLIGHTS_SPECIAL_MEALS_MEAL_SELECTED_LABEL');
            } else{
                this.errorCode = this.$filter('translate')('MMB_ANCILLARIES_SPECIAL_MEALS_LESS_THAN_24_HOURS_CONTENT');
            }
        } else {
            this.errorCode = this.currentSegment.status.reason;
        }
    };
    getCurrentPassengers = (): any => {
        if (!(this.currentSegment && this.currentSegment.id)) {
            this.currentSegment = this.model.specialMealSegments[0];
        }
        return Object.values(this.menus[this.currentSegment.id].passengers);
    };
    /**
     * Fill menus for each segment and passenger with default values
     */
    fillMenus = (): void => {
        // with this loop we go through the segments
        let i, j, z, k, userValid = false, listUserInfants = [];
        const auxData = this.localStorageService.get('specialMealsTempInfo');
        if (auxData) {
            this.menus = auxData;
        } else {
            for (i = 0; i < this.model.specialMealSegments.length; i++) {
                listUserInfants = [];
                const segment = this.model.specialMealSegments[i];
                this.menus[segment.id] = {
                    segment: segment.id,
                    passengers: {}
                };

                // with this loop we travel the passengers by segment
                for (j = 0; j < this.model.passengersInfo.length; j++) {
                    const passenger = this.model.passengersInfo[j];
                    userValid = false;
                    for (k = 0; k < segment.passengers.length; k++) {
                        if (segment.passengers[k] === passenger.id) {
                            userValid = true;
                            break;
                        }
                    }

                    if (userValid) {
                        if (segment.status.code === 'NOT_AVAILABLE' && (
                            segment.status.reason === 'com.ib.captwo.ass.fass.error.ASS_FASS_9021' ||
                            segment.status.reason === 'com.ib.captwo.ass.fass.error.ASS_FASS_9022'
                        )) {
                            this.menus[segment.id].passengers[passenger.id] = {
                                id: passenger.id,
                                name: passenger.name,
                                surname: passenger.surname,
                                menu: this.specialMealDefault,
                                menudesc: this.specialMealNotIncluded,
                                infant: passenger.infant
                            };
                        } else {
                            this.menus[segment.id].passengers[passenger.id] = {
                                id: passenger.id,
                                name: passenger.name,
                                surname: passenger.surname,
                                menu: this.specialMealDefault,
                                menudesc: this.specialMealDefaultDesc,
                                infant: passenger.infant
                            };
                        }
                    } else {
                        if (passenger.infant) {
                            listUserInfants.push(passenger);
                        }
                    }
                }
                angular.forEach(listUserInfants, (i) => {
                    this.menus[segment.id].passengers[i.relatedPassengerId].infant = true;
                    this.menus[segment.id].passengers[i.relatedPassengerId].nameInfant = i.name;
                    this.menus[segment.id].passengers[i.relatedPassengerId].surnameInfant = i.surname;
                });

            }



            // replace the default values with the preselected meals
            if (this.model.orderedMeals.length > 0) {
                for (z = 0; z < this.model.orderedMeals.length; z++) {
                    this.menus[this.model.orderedMeals[z].segmentId].passengers[this.model.orderedMeals[z].passengerId].menu = this.model.orderedMeals[z].serviceCode;
                    this.menus[this.model.orderedMeals[z].segmentId].passengers[this.model.orderedMeals[z].passengerId].menudesc = this.model.orderedMeals[z].description;
                }
            }
        }
    };

    /**
     * Function that updates the description of the menu by selecting it
     */
    selectedMeal = (): void => {
        if (this.menus[this.currentSegment.id].passengers[this.currentPassenger.id].menu === 'standard') {
            this.menus[this.currentSegment.id].passengers[this.currentPassenger.id].menudesc = this.specialMealDefaultDesc;
        } else {
            const menu = this.currentSegment.specialMeals.filter((meal) => {
                return meal.code === this.menus[this.currentSegment.id].passengers[this.currentPassenger.id].menu;
            });
            if (menu.length > 0) {
                this.menus[this.currentSegment.id].passengers[this.currentPassenger.id].menudesc = menu[0].description || menu[0].name;
            }
        }
    };


    /**
     * Cancel modal
     * @returns Reject promise
     */
    close = (): void => {
        this.$uibModalInstance.dismiss();
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('updatePageType');
    };

    nextSegment = (): void => {
        if (this.currentSegmentIndex + 1 < this.totalSegment) {
            this.currentSegmentIndex++;
            this.currentSegment = this.model.specialMealSegments[this.currentSegmentIndex];
            // update the passenger scroll according to the current segment
            this.passengers = this.getCurrentPassengers();
            this.currentPassengerIndex = 0;
            this.currentPassenger = this.model.passengersInfo[this.currentPassengerIndex];
            this.$scope.$broadcast('selectFirstPassenger', { index: this.currentPassengerIndex });
        }
        if (this.currentSegmentIndex === this.totalSegment - 1) {
            this.lastSegment = true;
        }
        this.errorFilter();
    };

    prevSegment = (): void => {
        if (this.currentSegmentIndex - 1 >= 0) {
            this.currentSegmentIndex--;
            this.currentSegment = this.model.specialMealSegments[this.currentSegmentIndex];
            // update the passenger scroll according to the current segment
            this.passengers = this.getCurrentPassengers();
            this.lastSegment = false;
            this.currentPassengerIndex = 0;
            this.currentPassenger = this.model.passengersInfo[this.currentPassengerIndex];
            this.$scope.$broadcast('selectFirstPassenger', { index: this.currentPassengerIndex });
        }
        this.errorFilter();
    };

    showButtonNext = (): boolean => {
        if (this.currentSegmentIndex + 1 < this.totalSegment) {
            return true;
        }
        return false;
    };

    showButtonPrev = (): boolean => {
        if (this.currentSegmentIndex > 0) {
            return true;
        }
        return false;
    };

    /**
     * Scroll to passenger when is selected in scroll list component
     * @param {*} evt
     * @param {*} idPassenger
     */
    selectScrollPassenger = (evt: any, idPassenger: any): void => {
        this.currentSegment = this.model.specialMealSegments[this.currentSegmentIndex];
        this.currentPassenger = this.menus[this.currentSegment.id].passengers[idPassenger];
    };

    sendMenus = (): void => {
        this.DatalayerUtilsService.updateDatalayerActionForAncillaries(this.AncillariesConstants.DATALAYER_INFO.SPECIAL_MEALS_CONFIRM, this.AncillariesConstants.DATALAYER_INFO.CLICK,
            this.AncillariesConstants.DATALAYER_INFO.CONFIRM);
        angular.forEach(Object.keys(this.menus), (menu, j) => {
            angular.forEach(Object.keys(this.menus[menu].passengers), (passenger, i) => {
                if(this.menus[menu].passengers[passenger].menu === undefined) {
                    this.menus[menu].passengers[passenger].menu = 'standard';
                }
            });
        });
        this.AncillariesMealsService.updatePassengersMeals(this.menus);
        this.$uibModalInstance.dismiss();
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('updatePageType');
    };

    filterAvailableSegments = ():void => {
        this.model.specialMealSegments = this.model.specialMealSegments.filter(segment => segment.status.code === 'AVAILABLE');
    };

    filterAvailableOrderMeals = ():void => {
        const segmentsAvailables = this.model.specialMealSegments.map(segment => segment.id);
        this.model.orderedMeals = this.model.orderedMeals.filter(meal => segmentsAvailables.includes(meal.segmentId));
    };
}


try {
    SpecialMealsController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(SpecialMealsController.name, SpecialMealsController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    SpecialMealsController.$inject = controllerInfo.inject;
    mod.controller(SpecialMealsController.name, SpecialMealsController);
}